import { createFileRoute } from '@tanstack/react-router'
import { WarrantyClaimsPage } from '@/features/warranty-claims/warranty-claims-page'

export const Route = createFileRoute('/_authenticated/warranty-claims')({
  staticData: { title: 'Warranty claims' },
  component: WarrantyClaimsPage,
})
